import 'react-dropdown-now/style.css';
import 'react-datepicker/dist/react-datepicker.css';
import React, { useEffect, useState } from 'react';
import Autocomplete from 'react-autocomplete';
import DatePicker from 'react-datepicker';
import { Dropdown } from 'react-dropdown-now';
import Toggle from 'react-toggle';

import axios from 'axios';

import './TextField.scss';
interface TextFieldProps {
  label: string;
  value?: any;
  onChange?: (value: any) => any;
  onToggle?: (value: boolean) => any;
  onToggleLock?: (value: boolean) => any;
  size?: 'small' | 'medium' | 'large';
  className?: string;
  disabled?: boolean;
  toggle?: boolean;
  toggleLock?: boolean;
  dropdown?: string[];
  autoComplete?: any;
  datepicker?: any;
  type?: string;
  emptyValue?: string;
}

const Pencil = () => (
  <div
    style={{
      color: '#fff',
      fontSize: '1.2em',
      position: 'absolute',
      top: '0.4em',
    }}
  >
    ✎
  </div>
);

export function TextField(props: TextFieldProps) {
  const [toggleChecked, setToggleChecked] = useState<boolean>(
    props.datepicker && props.value ? true : !props.disabled,
  );
  const [toggleLockChecked, setToggleLockChecked] = useState<boolean>(false);
  const [autoCompleteItems, setAutoCompleteItems] = useState<any>();
  const [value, setValue] = useState<string>(props.value || '');
  const [oldValue, setOldValue] = useState<string>(props.value || '');
  const requestTimer = null;

  useEffect(() => {
    if (props.autoComplete) setAutoCompleteItems(props.autoComplete);
  }, []);

  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  useEffect(() => {
    if (props.onToggle) {
      props.onToggle(toggleChecked);
      if (props.toggleLock && props.onToggleLock) props.onToggleLock(toggleChecked);
    }
    if (toggleChecked) {
      setValue(oldValue);
      if (props.onChange) props.onChange(oldValue);
    } else {
      setOldValue(value);
      setValue(isNaN(props.emptyValue) ? '' : props.emptyValue);
      if (props.onChange) props.onChange(isNaN(props.emptyValue) ? '' : props.emptyValue);
    }
  }, [toggleChecked]);

  useEffect(() => {
    if (props.onToggleLock) props.onToggleLock(!toggleLockChecked);
  }, [toggleLockChecked]);

  /*
  <Dropdown
    placeholder="Vesting Started Already?"
    options={['Yes', 'No']}
    value={newVestingCalendar.vestingStarted || ''}
    onChange={value => {
      setNewVestingCalendar({
        ...newVestingCalendar,
        vestingStarted: value,
      });
    }}
    onSelect={value => console.log('selected!', value)} // always fires once a selection happens even if there is no change
    onClose={closedBySelection =>
      console.log('closedBySelection?:', closedBySelection)
    }
    onOpen={() => console.log('open!')}
  />

  <DatePicker
    placeholder="TGE Date"
    selected={
      newVestingCalendar.tgeDate
        ? new Date(newVestingCalendar.tgeDate)
        : new Date()
    }
    onChange={(date: any) => {
      setNewVestingCalendar({
        ...newVestingCalendar,
        tgeDate: date,
      });
    }}
  />
  */

  return (
    <div
      className={`text-field-toggled size-${props.size ? props.size : 'medium'} ${
        props.className ? props.className : ''
      } ${value || (props.toggle && !toggleChecked) ? 'show-label' : ''}  ${
        props.toggleLock ? 'toggle-lock' : ''
      } ${props.toggleLock && !toggleLockChecked ? 'toggle-locked' : ''} ${
        props.toggle ? 'toggled' : ''
      } ${props.autoComplete ? 'text-field-autocomplete' : ''}`}
    >
      {(value || (props.toggle && !toggleChecked)) && <label>{props.label}</label>}
      {props.dropdown && (
        <Dropdown
          placeholder={props.label}
          options={props.dropdown}
          value={value || ''}
          onChange={value => {
            if (props.onChange) props.onChange(value);
            setValue(value);
          }}
        />
      )}

      {props.autoComplete && (
        <Autocomplete
          inputProps={{ placeholder: props.label }}
          autoHighlight={false}
          getItemValue={item => item}
          items={autoCompleteItems || []}
          value={value}
          onChange={e => {
            clearTimeout(requestTimer);
            setValue(e.target.value);
            axios({
              url: `${process.env.REACT_APP_API}/fetchTokenNames.php?q=${e.target.value}`,
              headers: { 'Content-Type': 'application/json' },
              withCredentials: true,
            }).then((response: any) => {
              if (response.data) setAutoCompleteItems(response.data);
            });
          }}
          onSelect={value => {
            if (props.onChange) props.onChange(value);
            setValue(value);
          }}
          renderMenu={children => (
            <div className="rdn">
              <div className="rdn-drop">{children}</div>
            </div>
          )}
          renderItem={(item, isHighlighted) => (
            <div
              className={`rdn-drop-menu-option ${isHighlighted ? 'item-highlighted' : ''}`}
              key={item.name}
            >
              {item.label}
            </div>
          )}
        />
      )}

      {props.datepicker && (!props.toggle || (props.toggle && toggleChecked)) && (
        <DatePicker
          placeholderText={props.label}
          selected={value ? new Date(value) : ''}
          onChange={(date: any) => {
            if (props.onChange) props.onChange(date);
            setValue(date);
          }}
        />
      )}

      {!props.dropdown && !props.autoComplete && (
        <>
          {(!props.toggle || (props.toggle && toggleChecked)) && !props.datepicker && (
            <input
              value={value || ''}
              onChange={(e: any) => {
                if (props.onChange) props.onChange(e.target.value);
                setValue(e.target.value);
              }}
              readOnly={props.toggleLock && !toggleLockChecked ? true : false}
              type={props.type || 'text'}
              placeholder={props.label}
            />
          )}
          {props.toggle && !toggleChecked && (
            <span>
              <input value={(props.datepicker ? '-' : '-') || '-'} type="text" disabled={true} />
            </span>
          )}
          {props.toggle && (
            <Toggle
              className="toggle-class"
              checked={toggleChecked}
              onChange={() => {
                setToggleChecked(!toggleChecked);
              }}
            />
          )}

          {props.toggleLock && (
            <Toggle
              className="toggle-class toggle-locked"
              checked={toggleLockChecked}
              disabled={props.toggle && !toggleChecked ? true : false}
              icons={{
                checked: <Pencil />,
                unchecked: <Pencil />,
              }}
              onChange={() => {
                setToggleLockChecked(!toggleLockChecked);
              }}
            />
          )}
        </>
      )}
    </div>
  );
}
